import { render } from "./index.vue?vue&type=template&id=33f3dd58&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=33f3dd58&lang=scss&scoped=true"

import exportComponent from "/Users/wangzicheng/Documents/kaola/projectWork/kaola/project-helpCenter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f3dd58"]])

export default __exports__